import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';

const defaultStyle = { width: 0 };

export const StyledDatagridConfigurableWithStickyActions = styled(
  DatagridConfigurableWithStickyActions,
)({
  '& .column-name': defaultStyle,
  '& .column-alias': defaultStyle,
  '& .column-roles': defaultStyle,
  '& .column-merchants': defaultStyle,
  '& .column-activityUpdatedAt': defaultStyle,
  '& .column-apiKeys': defaultStyle,
  '& .column-securityIssues': defaultStyle,
  '& .column-createdAt': defaultStyle,
  '& .column-updatedAt': defaultStyle,
  '& .column-undefined': defaultStyle,
  '& .column-active': {
    textAlign: 'center',
    ...defaultStyle,
  },
  '& .MuiSwitch-root': {
    right: '6px',
    top: '-8px',
  },
});
